
import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";
import {
  SplitTruckSummaryOrder,
  SplitTruckSummary,
} from "../../models/api/trucks/splitTrucks";
import draggable from "vuedraggable";
import { formatDate, formatAddress, formatDecimal, formatBool } from "@/utils";
import { looseEqual } from "@/lib/utilities";
import { Address, OrderParty } from "@/models/api/orders/get";
import _ from "lodash";
import { OrderModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";


const orderModule = getModule(OrderModule);

@Component({
  components: {
    draggable,
  },
})
export default class SplitTruckOrdersTable extends Vue {
  sortField: string = null;
  sortDirection: string = "asc";
  localValue: SplitTruckSummaryOrder[] = null;
  additionalInfoOrder: SplitTruckSummaryOrder = null;
  showOrderAdditionalInfo: boolean = false;
  updating: boolean = false;

  @Prop({ default: false })
  public isOrigTruck: boolean;

  @Prop({ default: [] })
  public value: SplitTruckSummaryOrder[];

  @Prop({ default: "tableOrders" })
  public group: any;

  created() {
    this.localValue = JSON.parse(JSON.stringify(this.value));
  }

  format(date) {
    return formatDate(date);
  }

  formatDecimal(value){
    return formatDecimal(value);
  }

  formatBool(value){
    return formatBool(value);
  }

  formatAddress(address: Address) {
    return formatAddress(address);
  }

  @Watch("value")
  onValueChange(val: any, oldVal: any) {
    this.localValue = JSON.parse(JSON.stringify(val));
  }

  @Watch("localValue")
  onLocalValueChange(val: any, oldVal: any) {
    if (!looseEqual(val, this.value)) {
      this.$emit("input", val);
    }
  }

  onClickAdditionalInfo(order) {
    //this.additionalInfoOrder = order;
    //this.showOrderAdditionalInfo = true;
    this.previewOrder(order.cdsNumber);
  }

  onClickOrderNotes(order) {
    this.viewOrderNotes(order.cdsNumber);
  }

  hasAdditionalInfo(order) {
     return (order.cdsNumber != null)
  }

  closeAdditionalInfo() {
    this.additionalInfoOrder = null;
    this.showOrderAdditionalInfo = false;
  }

  onClickMapPin(order) {
    this.$emit("mapPinClicked", order);
  }
    
  onClickNoMapPin(order) {
    this.$emit("geoCodeAddress", order);
  }

  onMoveOrderToOtherTruck(order) {
    this.$emit("moveOrderToOtherTruck", order);
  }

  previewOrder(orderHeaderNumber) {
    orderModule.orderPreviewShortcutAction({ selectedItems: [{ number: orderHeaderNumber }] });
  }

  viewOrderNotes(orderHeaderNumber) {
    orderModule.notesShortcutAction({ selectedItems: [{ number: orderHeaderNumber }] });
  }

  getMapPinIconColor(order: SplitTruckSummaryOrder)
  {
    if(order.location && order.location.isZipCodeLocation == true )
      return "red";
    return "green";
  }

  sort(fieldName) {
    if (this.sortField == fieldName)
      this.sortDirection = this.sortDirection == "asc" ? "desc" : "asc";
    else {
      this.sortDirection = "asc";
      this.sortField = fieldName;
    }

    this.localValue = _.orderBy(
      this.localValue,
      [this.sortField],
      [this.sortDirection]
    );
    this.$emit("input", this.localValue);
  }

  dragEnd(event) {
    this.updating = true;
    var orders = [...this.localValue];
    this.localValue = [];

    this.$nextTick(() => {
      this.localValue = orders;
      this.updating = false;
    });
  }
}
